// Module
var code = "<span class=\"glyphicon glyphicon-info-sign later-then ng-invalid error-message-tooltip\" tooltip-placement=\"tooltipPlacement\" tooltip-html-unsafe=\"{{validationLaterThenMessage}}\" tooltip-append-to-body=\"true\" ng-hide=\"laterThenValid\"></span>";
// Exports
module.exports = code;